import { z } from "zod";

export const BillApproversSchema = z.object({
  level: z.number(),
  watcherGroupsUsers: z.array(
    z.object({
      group: z
        .object({
          id: z.string(),
          createdAt: z.date(),
          updatedAt: z.date(),
          name: z.string(),
          companyId: z.string(),
        })
        .nullable(),
      users: z.array(
        z.object({
          id: z.string(),
          firstName: z.string(),
          lastName: z.string(),
          email: z.string(),
        }),
      ),
      department: z
        .object({
          id: z.string(),
          name: z.string(),
        })
        .nullish(),
      businessUnit: z
        .object({
          id: z.string(),
          name: z.string(),
        })
        .nullish(),
    }),
  ),
  approverGroupsUsers: z.array(
    z.object({
      group: z
        .object({
          id: z.string(),
          name: z.string(),
        })
        .nullable(),
      users: z.array(
        z.object({
          id: z.string(),
          firstName: z.string(),
          lastName: z.string(),
          email: z.string(),
        }),
      ),
      department: z
        .object({
          id: z.string(),
          name: z.string(),
        })
        .nullish(),
      businessUnit: z
        .object({
          id: z.string(),
          name: z.string(),
        })
        .nullish(),
    }),
  ),
});

export type BillApprovers = z.infer<typeof BillApproversSchema>;
